import { render, staticRenderFns } from "./ProductManufactureModal.vue?vue&type=template&id=2a3d334e&scoped=true&"
import script from "./ProductManufactureModal.vue?vue&type=script&lang=js&"
export * from "./ProductManufactureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3d334e",
  null
  
)

export default component.exports